module.exports = __webpack_public_path__ + "images/emoji/stars.fe50548f98f7fb911179.png";